import * as z from "zod/v4";
import { hsaOrderContext } from "../hsa-order-context";

// Where the questionnaire is being rendered. Discriminator on the
// createHsaSession input — *not* persisted on the session row. CHECKOUT
// callers must supply order context and a completion redirect; STOREFRONT
// callers (PDP modal) can't, because there's no cart yet.
export const HSA_QUESTIONNAIRE_LOCATIONS = ["STOREFRONT", "CHECKOUT"] as const;
export type HsaQuestionnaireLocation =
  (typeof HSA_QUESTIONNAIRE_LOCATIONS)[number];

// Input schema for the createHsaSession RPC. A discriminated union on
// `location` so the type system enforces that CHECKOUT callers always
// supply orderContext + completedRedirectUrl, and STOREFRONT callers
// never accidentally do.
export const createHsaSessionInput = z.discriminatedUnion("location", [
  z.object({
    location: z.literal("CHECKOUT"),
    orderContext: hsaOrderContext,
    completedRedirectUrl: z.string().url(),
  }),
  z.object({ location: z.literal("STOREFRONT") }),
]);

export const createHsaSessionOutput = z.object({
  sessionToken: z.string().uuid(),
});
